import { createFileRoute } from '@tanstack/react-router';
import { RelatorioCompra } from '@/features/relatorio/page/compra/RelatorioCompra';

export const Route = createFileRoute('/a/relatorio/compra/')({
    component: RelatorioCompra,
});
